import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectInvite} from 'api/invite';
import {loadLeadInvite as load, submitLeadInvite as submit} from 'flows/lead/invite/index';
import Spinner from 'components/Spinner';

import LeadInvite from './component';

export class LeadInviteContainer extends React.Component {
  constructor() {
    super();
    this.login = this.login.bind(this);
  }
  componentDidMount() {
    this.props.load({id: this.props.params.inviteId});
  }
  login() {
    this.props.submit({id: this.props.params.inviteId});
  }
  render() {
    const {data, loaded} = this.props.invite || {};

    if (loaded) {
      return (
        <LeadInvite login={this.login} invite={data} />
      );
    }
    return (
      <Spinner />
    );
  }
}

LeadInviteContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  invite: PropTypes.object,
  params: PropTypes.object.isRequired,
};

export const mapStore = (store, ownProps) => ({
  invite: selectInvite(store, ownProps.params.inviteId)
});

export default connect(mapStore, {load, submit})(LeadInviteContainer);



// WEBPACK FOOTER //
// ./web/flows/lead/invite/index.js